/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {formatDate} from '@angular/common';
import * as moment from 'moment';
import {tz} from "moment";

@Pipe({
  name: 'wellDate',
  standalone: true,
})
export class WellDatePipe implements PipeTransform {

  format = 'dd MMM HH:mm';

  constructor(@Inject(LOCALE_ID) private locale: string) {
  }

  transform(value: any, format?: string, timezone?: string, locale?: string): any {

    if (value == null || value === '' || value !== value) {
      return null;
    }

    if (format) {
      this.format = format;
    }

    try {
      if (timezone) {
        moment.locale('en');
        return tz(value, null, timezone).format(format);
      } else {
        return formatDate(value, this.format, locale || this.locale);
      }
    } catch (error) {
      throw new Error(error.message);
    }

  }
}
